var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "form",
      staticClass: "subscription_prefs_form",
      attrs: {
        method: "post",
        action:
          "https://australia-southeast1-foxtware.cloudfunctions.net/apexShopifyCustomerInfoUpdate",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.update.apply(null, arguments)
        },
      },
    },
    [
      _c("h2", [_vm._v("Get the Goss")]),
      _vm._v(" "),
      _c("div", { staticClass: "consent_controls" }, [
        _c("div", { staticClass: "consent_control" }, [
          _c("span", {
            staticClass: "consent_control_icon",
            domProps: {
              innerHTML: _vm._s(_vm.theme.icons.mail("auto", "auto")),
            },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { name: "accepts_email", type: "hidden", value: "false" },
          }),
          _vm._v(" "),
          _c("input", {
            attrs: {
              name: "accepts_email",
              id: "accepts_email",
              type: "checkbox",
              value: "true",
            },
            domProps: { checked: _vm.acceptsEmailState },
            on: { change: _vm.touch },
          }),
          _vm._v(" "),
          _c("label", { attrs: { for: "accepts_email" } }, [_vm._v("Email")]),
        ]),
        _vm._v(" "),
        _vm.sms_consentable === "true"
          ? _c("div", { staticClass: "consent_control" }, [
              _c("span", {
                staticClass: "consent_control_icon _loppy",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.theme.icons.mobile_message("auto", "auto")
                  ),
                },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: { name: "accepts_sms", type: "hidden", value: "false" },
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  name: "accepts_sms",
                  id: "accepts_sms",
                  type: "checkbox",
                  value: "true",
                },
                domProps: { checked: _vm.acceptsSmsState },
                on: { change: _vm.touch },
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "accepts_sms" } }, [
                _vm._v("Mobile"),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "submit", disabled: !_vm.touched },
          domProps: { innerHTML: _vm._s(_vm.buttonHtml) },
        },
        [_vm._v("Update")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }